import { useRef, useState } from "react";
import type { TextInput as TextInputBase } from "react-native";
import { Button } from "~/components/Button";
import { TextInput, type TextInputProps } from "~/components/form/TextInput";
import { Padding } from "~/constants/layout";

export type PasswordInputProps = {
    label?: string;
    optional?: boolean;
} & TextInputProps;

export const PasswordInput = ({ label = "Password", disabled, ref, ...textInputProps }: PasswordInputProps) => {
    const [masked, setMasked] = useState<boolean>(true);
    const localRef = useRef<TextInputBase>(null);
    const inputRef = ref ?? localRef;

    const toggleMasked = () => {
        setMasked(!masked);
        inputRef.current?.focus();
    };

    return (
        <TextInput
            {...textInputProps}
            label={label}
            secureTextEntry={masked}
            disabled={disabled}
            ref={inputRef}
            right={() => (
                <Button
                    innerStyle={Padding.none}
                    iconSize={20}
                    variant="neutral-quiet"
                    icon={masked ? "view-on" : "view-off"}
                    onPress={toggleMasked}
                    disabled={disabled}
                />
            )}
        />
    );
};
